import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import ArtistList from "./ArtistList";
import { RemovableArtist } from "components/Removables/RemovableArtist";
import { ModalPickerProps } from "../props";
import { companyToArtist } from "utilities/companyUtils";
import CompanyNewModal from "company/new/App";

interface Props extends ModalPickerProps<server.dto.ArtistSmall> {
  securityScope: server.dto.ArtistSecurityScopes;
}

const ArtistModalPicker = (props: Props) => {
  const [displayNewCompanyModal, setDisplayNewCompanyModal] = React.useState(false);

  return <>
    {displayNewCompanyModal && <CompanyNewModal
      onClose={() => setDisplayNewCompanyModal(false)}
      onCreated={(c) => {
        props.onChange(companyToArtist(c));
        setDisplayNewCompanyModal(false);
      }}
      defaults={{ isArtist: true }}
      disableArtist
    />}

    <ModalPickerWithChooseButton
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.artist.plural}
      modalSize="mini"
      renderModalContent={(closeModal) => <ArtistList
        securityScope={props.securityScope}
        onItemSelected={(artist) => {
          closeModal();
          props.onChange(artist);
        }}
      />}
      renderRemovable={(props) => <RemovableArtist {...props} />}
      onNewClicked={() => setDisplayNewCompanyModal(true)}

      {...props}
    />
  </>;
};

export default ArtistModalPicker;